<template>
    <div class="navigation">
		<img class="logo" src="/images/moovr_icon_red.svg" alt="icon">
		<div :class="'navigation__pos navigation__pos--' + index" v-for="(pos, index) in positions" :key="index">
			<div :class="'navigation__item' + (item.inPath ? ' navigation__item--active' : '')" v-for="item in pos" :key="item.name" @click="$emit('itemClick', item.link)">
				<svgicon :icon="item.icon" class="navigation__item__icon" />
				<div class="navigation__item__label">{{ item.label }}</div>
				<div class="navigation__item__marker" />
				<div v-if="item.badge > 0" class="navigation__item__badge">{{ item.badge }}</div>
			</div>
		</div>
    </div>
</template>

<script>
    export default {
		props: ['items'],
		watch: {
			'item.badge': function (val, oldVal) {
				console.log(`Changed from ${oldVal} to ${val}`);
			}
		},
		methods: {
			inPath(name) {
				for (var i = 0; i < this.$route.matched.length; ++i) {
					if (this.$route.matched[i].name == name) return true;
				}

				return false;
			}
		},
		computed: {
			positions() {
				var pos = {};
				var prop;
				var item;

				for (var i in this._items) {
					item = this._items[i];
					prop = item.hasOwnProperty('pos') ? item.pos : 'default';

					if (pos.hasOwnProperty(prop)) {
						pos[prop].push(item);
					} else {
						pos[prop] = [item];
					}
				}

				return pos;
			},
			_items() {
				var item;
				var r = [];

				/*console.log(this.$store.state.employee.privileges);

				for (var i = 0; i < this.items.length; ++i) {
					item = this.items[i];

					// Mobile?
					if (!item.meta.mobile) {
						continue;
					}

					// Access to page
					if (!this.$store.state.employee.privileges || !this.$store.state.employee.privileges[item.name] || (item.module !== null && !this.$store.state.employee._embedded.customer.modules.includes(item.module))) {
						continue;
					}

					// Access to any child
					item.link = null;

					if (item.children === null) {
						item.link = item.name;
					} else {
						for (var j = 0; j < item.children.length; ++j) {
							var child = item.children[j];
							console.log(child);
							console.log(this.$store.state.employee.privileges);

							if (this.$store.state.employee.privileges && this.$store.state.employee.privileges[child.name]) {
								item.link = child.name;
								break;
							}
						}
					}

					if (!item.link) {
						continue;
					}

					item.inPath = this.inPath(this.items[i].name);

					r.push(item);
				}*/

				return r;
			}
		},
		mounted() {
			console.log(this.$route);
			console.log(this.items);
		}
    }
</script>

<style lang="scss">
	.navigation {
		background-color: #45a9f2;
		overflow: hidden;

		& > .logo {
			width: 30px;
			margin: 20px 0 0 20px;
		}

		&__item {
			position: relative;
			width: 100%;
			height: 60px;
			cursor: pointer;

			&__icon {
				position: absolute;
				left: 25px;
				top: 20px;
				width: 20px;
				height: 20px;
				line-height: 60px;	
				text-align: center;	
				fill: #ffffff55;
				transition: all 250ms;
			}

			&:hover &__icon, &--active &__icon {
				fill: white;
			}

			&__label {
				position: absolute;
				left: 70px;
				top: 0;
				right: 0;
				bottom: 0;
				line-height: 60px;
				color: white;
			}

			&__marker {
				position: absolute;
				left: 0;
				top: 20px;
				bottom: 20px;
				width: 0;
				background-color: #61ce70;
				transition: all 250ms;
				opacity: 0;
			}

			&--active &__marker {
				width: 4px;
				opacity: 1;
			}
		}
	}
</style>